import React, { useState, useEffect } from "react";
// import "./ChooseBattle.css";
import "./iplbattle.css";
import { ChooseFavHateTeam } from "../../../apis/iplBattle";
import useUserInfo from "../../../Hooks/useUserInfo";
import MatchScheduleList from "./matchsceduleList";
import Swal from "sweetalert2";
import vs from "../../../assets/images/Vs.png";
import { logPageView } from "../../../components/analytics";
import { getTeamColorsByLeague } from "../../../helpers/helpers";

const ComboScreen = (props) => {
  const goBack = () => {
    props?.setOpenPopup(false);
  };
  useEffect(() => {
    logPageView("UFW COMBO PAGE", "UFW COMBO PAGE");
  }, []);

  const favTeam = props?.favTeam;
  const hateTeam = props?.hateTeam;
  const [isLoading,setIsLoading]=useState(false);
  const { userDetails, watchScreen, updatewatchScreenInfo, updateUserInfo } =
    useUserInfo();
  const Apidata = props?.data;
  const goToThePage = (component, name) => {
    updateUserInfo((prev) => {
      return {
        ...prev,
        ...{
          currentComponent: component,
          currentComponentText: name,
          lastComponent: userDetails?.currentComponent,
          lastComponentText: userDetails?.currentComponentText,
          centerCount: userDetails?.centerCount + 1,
        },
      };
    });
  };
  const SaveCombo = async (data) => {
    console.log(data, "Apidata");
    if (!data) {
      alert("jg");
      return;
    }

    try {
      setIsLoading(true);
      const response = await ChooseFavHateTeam(data); // Assuming this is an API call
      console.log(response, "response");

      if (response) {
        setIsLoading(false);
        goToThePage(MatchScheduleList, "MatchScheduleList");
        // Ensure API call is successful
        // Swal.fire({
        //   title: "Success!",
        //   text: "Successfully saved",
        //   icon: "success",
        //   confirmButtonText: "OK",
        // }).then(() => {
        //   goToThePage(MatchScheduleList, "MatchScheduleList");
        // });
      }
    } catch (error) {
      console.error("Error saving:", error);
      Swal.fire({
        title: "Error!",
        text: "Something went wrong",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  const FavTeamBgColorFilter = getTeamColorsByLeague(favTeam?.teamName, watchScreen?.cricketLeague);
  const FavTeamBgColor = FavTeamBgColorFilter?.background;

  const HateTeamBgColorFilter = getTeamColorsByLeague(hateTeam?.teamName, watchScreen?.cricketLeague);
  const HateTeamBgColor = HateTeamBgColorFilter?.background;

  console.log(HateTeamBgColor,'FavTeamBgColor');

  return (
    <>
      <div className="overlayipl">
        <div class="spinning-animation-sv"></div>
        <div className="battle-content">
          {/* <div className="match-header">
          <h3 className="match-header-text">MATCH 21</h3>
        </div> */}
          <div className="outline">
            <div className="content">
              <p className="choose-text text-uppercase">Your combo is ready!</p>
            </div>
          </div>
          <div className="characters-container">
            <div className="red-character">
              <div className="team-1">
                <img
                  src={favTeam?.teamLogo}
                  alt="PEPE"
                  className="character-image"
                />
              </div>

              <div className="shiba-text text-uppercase " style={{background:FavTeamBgColor}}>
                {favTeam?.teamName}
              </div>
              {/* <ul className="team-stats red">
              <li>
                {" "}
                RANK<span className="value">2</span>
              </li>
              <li>
                WIN<span className="value">5</span>
              </li>
              <li>
                LOSE<span className="value">2</span>
              </li>
            </ul> */}
              <button
                onClick={goBack}
                className="team-shiba-btn text-uppercase"
              >
                Back to select
              </button>
            </div>

            {/* <img src={vs} className="vs-text" alt="VS" /> */}

            <div className="green-character">
              <div className="team-2">
                <img
                  src={hateTeam?.teamLogo}
                  alt="CSK"
                  height={200}
                  className="character-image"
                />
              </div>

              <div className="pepe-text text-uppercase" style={{background:HateTeamBgColor}}>
                {hateTeam?.teamName}
              </div>
              {/* <ul className="team-stats green">
              <li>
                {" "}
                RANK<span className="value">2</span>
              </li>
              <li>
                WIN<span className="value">3</span>
              </li>
              <li>  
                LOSE<span className="value">1</span>
              </li>
            </ul> */}
              <button
                onClick={() => SaveCombo(Apidata)}
                className="team-pepe-btn  text-uppercase"
              >
                  {isLoading ? (
                    <div className="loader-spin">
                      <div className="spinner"></div>{" "}
                    </div>
                  ) :'  Save Combo'}
              
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ComboScreen;
